export const tvCategories = {
  INICIAL: "INICIAL",
  LIGHT_DIGITAL: "LIGHT_DIGITAL",
  MIX_DIGITAL: "MIX_DIGITAL",
  TOP_DIGITAL: "TOP_DIGITAL",
};
